import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { getSeoData } from '../data/seoData';

function SEO() {
  const location = useLocation();
  const seo = getSeoData(location.pathname);

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="keywords" content={seo.keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={`https://www.p3dentalpc.com${location.pathname}`} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:site_name" content="P3 Dental of Northeast Philadelphia" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={`https://www.p3dentalpc.com${location.pathname}`} />
    </Helmet>
  );
}

export default SEO;
